import {PIXI, Scrollbox} from '@colonist/pixi'
import {SectionView} from '../../ui_canvas_engine/SectionView'
import {UIGameManager} from '../UIGameManager'
import {GameColor} from '../../GameColor'

export class UIGameOpponentsScrollbox extends Scrollbox {
    isScrollable: boolean

    constructor(x: number, y: number, width: number, height: number, container: PIXI.Container, uiGameManager: UIGameManager, hideScroll: boolean) {
        const canvas = uiGameManager.canvasController
        const margin = canvas.margin
        const scrollbarBgColor = GameColor.getColorHexValue(GameColor.Color.Gray1)
        const scrollbarFgColor = GameColor.getColorHexValue(GameColor.Color.White)

        super({
            boxWidth: width,
            boxHeight: height,
            scrollbarBackground: scrollbarBgColor,
            scrollbarForeground: scrollbarFgColor,
            scrollbarForegroundAlpha: 0.8,
            scrollbarSize: hideScroll ? 0 : width / 100,
            scrollbarOffsetVertical: -margin,
            events: uiGameManager.canvasController.app.renderer.events,
        })

        const scrollBoxBg = new SectionView(0, 0, width, height, this.content, true)
        container.addChild(this)
    }

    setIsScrollable() {
        this.isScrollable = this.boxHeight < this.content.height
    }
}
